import { Component, Output, EventEmitter, ChangeDetectionStrategy, Input } from '@angular/core';
import { ColorInjector } from '../ColorInjector';

// old foaming button
// <!-- style="color: #f49602; background-color: white; border: solid 1px #f49602" -->

// button with src
// <button type="button" (click)="onClick()" [matTooltip]="toolTip" mat-icon-button>
//   <img [src]="src" alt="{{ src }}" width="32" height="32" />
// </button>

@Component({
    selector: 'usimweb-button-icon',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <button
      *ngIf="round"
      mat-mini-fab
      [style.color]="fontColor"
      [style.background]="color"
      (click)="click()"
      aria-label="button-icon"
    >
      <mat-icon>{{ icon }}</mat-icon>
    </button>
    <button
      *ngIf="!round"
      [style.color]="fontColor"
      [style.border]="'none'"
      [style.background]="color"
      [style.padding]="'10px'"
      (click)="click()"
      aria-label="button-icon"
    >
      <mat-icon>{{ icon }}</mat-icon>
    </button>
  `,
    standalone: false
})
export class ButtonIconComponent extends ColorInjector {
  @Input() color: string = this.mainColor;

  @Input() fontColor: string = 'black';

  @Input() icon: string = '';

  @Input() tooltip: string = '';

  @Input() round: boolean = true;

  @Output() btnClick: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {}

  public click() {
    this.btnClick.emit();
  }
}
